import * as React from "react";
import Card from "react-bootstrap/Card";
import Image from "react-bootstrap/Image";
import Button from "react-bootstrap/Button";

class Reply extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      replies: [],
      buttonOpen: false,
    };
    this.handleClick = this.handleClick.bind(this);
  }
  render() {
    const comment = this.props.comment;
    return (
      <div>
        <Button id={comment.id} onClick={this.handleClick} style={{ margin: "10px 0" }}>
          <span className="replay-btn-text">
            {this.state.buttonOpen ? "Hide replies" : "Show replies"}
          </span>
          <span>({comment.snippet.totalReplyCount})</span>
        </Button>

        <div id={"content" + comment.id} className="col-md-12 replay-parent">
          {this.state.replies.length > 0 && this.state.buttonOpen === true
            ? this.state.replies.map((reply, index, replies) => {
                const date = new Date(
                  reply.snippet.publishedAt
                ).toLocaleString();
                return (
                  <Card key={index}>
                    <Card.Body>
                      <div>
                        <span className="cr-count">
                          Reply #: {replies.length - index}
                        </span>

                        <div className="user-info">
                          <Image
                            roundedCircle
                            className="img-user-avatar"
                            src={reply.snippet.authorProfileImageUrl}
                            alt="..."
                          />

                          <div>
                            <h3>
                              <a
                                href={reply.snippet.authorChannelUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                {reply.snippet.authorDisplayName}
                              </a>
                            </h3>

                            <p className="text-muted">Date published: {date}</p>
                          </div>
                        </div>
                      </div>

                      <Card.Text>{reply.snippet.textDisplay}</Card.Text>
                    </Card.Body>
                  </Card>
                );
              })
            : null}
        </div>
      </div>
    );
  }

  handleClick() {
    if (this.state.replies.length <= 0) {
      const url = `https://www.googleapis.com/youtube/v3/comments?part=snippet&parentId=${this.props.comment.id}&maxResults=100&key=${process.env.REACT_APP_YT_KEY}`;
      fetch(url)
        .then((response) => response.json())
        .then((data) => {
          this.setState({
            replies: data.items,
          });
        });
    }
    if (this.state.buttonOpen) {
      this.setState({
        buttonOpen: false,
      });
    } else {
      this.setState({
        buttonOpen: true,
      });
    }
  }
}

export default Reply;
